import { useLayoutEffect, useMemo, useRef } from 'react';
const useEventCallback = fn => {
  let ref = useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  });
  return useMemo(() => function () {
    const {
      current
    } = ref;
    return current(...arguments);
  }, []);
};
export default useEventCallback;